import { ApiResource } from '@/core/models/api-resource.interface';
import { TaskType } from './task-type.interface';

export class TaskTypeService {
   async getTaskTypes() {
      const response = await http.get<ApiResource<TaskType>>('/task-types', { ...cacheFirstConfig });
      return response.data;
   }
}
